module.exports = __webpack_public_path__ + "static/img/icon_cloud_p2.3feb320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_p2.jpg
// module id = KGnP
// module chunks = 21